import { CLEAR_CART, EXTRAS_CHANGE, HOSPITAL_CHANGE, PRODUCT_CHANGE } from '../action-types';
import { ProductType } from '../../types/product';

export type CartActionsType = {
  productChange(product: ProductType): {
    product: ProductType;
    type: typeof PRODUCT_CHANGE;
  };
  hospitalChange(product: ProductType | null): {
    product: ProductType;
    type: typeof HOSPITAL_CHANGE;
  };
  extrasChange(product: ProductType | null): {
    product: ProductType;
    type: typeof EXTRAS_CHANGE;
  };
  clearCart(): {
    type: typeof CLEAR_CART;
  };
};

function productChange(product: ProductType) {
  return {
    product,
    type: PRODUCT_CHANGE,
  };
}

function hospitalChange(product: ProductType) {
  return {
    product,
    type: HOSPITAL_CHANGE,
  };
}

function extrasChange(product: ProductType) {
  return {
    product,
    type: EXTRAS_CHANGE,
  };
}

function clearCart() {
  return {
    type: CLEAR_CART,
  };
}

export default {
  clearCart,
  extrasChange,
  hospitalChange,
  productChange,
};
